import React from 'react'
import { useParams } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { partnerHostStaging, partnerHostLive } from '../../../../../constants'

const Host = window.location.hostname

const QAPhotoInstructionsScreen = ({ history }) => {
  const { token, bookingId } = useParams()

  const handleSubmit = () => {
    history.push(
      `${
        Host === partnerHostLive || Host === partnerHostStaging
          ? '/'
          : '/partner/'
      }driver/app/details/qaCheck/preview/${token}/${bookingId}`
    )
  }

  return (
    <div className='qa-instructions-container'>
      <div>
        <img
          className='driver-back-icon-qa mx-50%'
          src='/images/icon-back.png'
          onClick={e => {
            e.preventDefault()
            window.history.back()
          }}
          alt='Back'
        />
      </div>

      <div className='qa-content-block'>
        <h2 className='qa-heading'>Chauffeur & vehicle quality check</h2>

        <div className='qa-photo-wrapper'>
          <div className='qa-photo-section'>
            <div className='qa-icon-circle'>
              <img
                src='/images/icons/icon-chauffeur-black.png'
                alt='Chauffeur'
                className='qa-photo-icon'
              />
            </div>
            <div className='qa-title'>Chauffeur photo</div>
            <div className='qa-text'>
              Take a clear photo of yourself wearing the required dress code.
            </div>
          </div>

          <div className='qa-photo-section'>
            <div className='qa-icon-circle'>
              <img
                src='/images/icons/icon_car.png'
                alt='Vehicle'
                className='qa-photo-icon'
              />
            </div>
            <div className='qa-title'>Vehicle photo</div>
            <div className='qa-text'>
              Take a photo of your vehicle's interior with all required
              amenities visible.
            </div>
          </div>
        </div>
      </div>

      <div className='driver-booking-cta-footer'>
        <Button
          className='select-btn select-vehicle mb-2'
          style={{
            width: '100%',
            fontWeight: '900',
            fontSize: '16px',
            textShadow: '0.25px 0 #ffffff',
          }}
          variant='brown'
          onClick={handleSubmit}
        >
          Next
        </Button>
      </div>
    </div>
  )
}

export default QAPhotoInstructionsScreen
